import { useVideoPlayback } from "@/contexts/playback-context";
import { getCameraImageSrc } from "@/shared/api/helpers";
import { useSelector } from "@legendapp/state/react";

export function CameraViewImage() {
  const videoPlayback = useVideoPlayback();
  const activeCamera = useSelector(() =>
    videoPlayback.videoContext.camera.get()
  );
  return (
    <div className="flex justify-center items-center bg-black w-full h-full">
      <img
        className="aspect-video w-full h-full object-contain"
        src={getCameraImageSrc(activeCamera)}
      />
    </div>
  );
}
